(function () {
  'use strict';

  var DESKTOP_MQ = '(min-width: 750px)';

  function getLayoutColumnCount(containerWidth) {
    if (containerWidth >= 500) return 5;
    if (containerWidth >= 380) return 4;
    return 3;
  }

  function getTrackGap(track) {
    var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap);
    return Number.isFinite(gap) ? gap : 10;
  }

  function getPageScrollPositions(track, layoutColumnCount) {
    var items = track.querySelectorAll('.variant-option__button-label--has-swatch');
    var itemCount = items.length;

    if (!itemCount || itemCount <= layoutColumnCount) return [0];

    var gap = getTrackGap(track);
    var itemWidth = items[0].offsetWidth;
    var step = Math.round(itemWidth + gap);
    var maxStart = itemCount - layoutColumnCount;
    var positions = [0];

    for (var start = layoutColumnCount; start < maxStart; start += layoutColumnCount) {
      positions.push(start * step);
    }

    var lastPosition = maxStart * step;
    if (positions[positions.length - 1] !== lastPosition) {
      positions.push(lastPosition);
    }

    return positions;
  }

  function getActivePageIndex(positions, scrollLeft) {
    var activeIndex = 0;

    for (var i = 0; i < positions.length; i += 1) {
      if (positions[i] <= scrollLeft + 2) activeIndex = i;
    }

    return activeIndex;
  }

  function getPageScrollY() {
    return (
      window.pageYOffset ||
      (document.scrollingElement && document.scrollingElement.scrollTop) ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0
    );
  }

  function getStickyHeaderOffset() {
    var bodyValue = parseFloat(document.body.style.getPropertyValue('--header-group-height'));
    if (Number.isFinite(bodyValue) && bodyValue > 0) return bodyValue;

    var rootStyles = window.getComputedStyle(document.documentElement);
    var rootValue = parseFloat(rootStyles.getPropertyValue('--header-group-height'));
    return Number.isFinite(rootValue) && rootValue > 0 ? rootValue : 0;
  }

  function scrollToProductMedia(picker) {
    if (picker.closest('dialog, .quick-add-modal, quick-add-component')) return;

    var section = picker.closest('.shopify-section') || document;
    var media =
      section.querySelector('.product-information__media') ||
      section.querySelector('media-gallery') ||
      section.querySelector('.product-media-container');

    if (!media) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    var top = getPageScrollY() + media.getBoundingClientRect().top - getStickyHeaderOffset();
    window.scrollTo({ top: Math.max(0, Math.round(top)), behavior: 'smooth' });
  }

  function scrollActiveSwatchIntoView(picker, layoutColumnCount, behavior, desktopMq) {
    if (desktopMq && !desktopMq.matches) return;

    var viewport = picker.querySelector('[data-pdp-swatch-picker-viewport]');
    var track = picker.querySelector('[data-pdp-swatch-picker-track]');
    if (!viewport || !track) return;

    var checked = picker.querySelector('input[type="radio"]:checked');
    if (!checked) return;

    var label = checked.closest('.variant-option__button-label--has-swatch');
    if (!label) return;

    var items = track.querySelectorAll('.variant-option__button-label--has-swatch');
    var itemCount = items.length;
    if (itemCount <= layoutColumnCount) return;

    var itemIndex = Array.prototype.indexOf.call(items, label);
    if (itemIndex < 0) return;

    var pageStartIndex = Math.min(
      Math.floor(itemIndex / layoutColumnCount) * layoutColumnCount,
      itemCount - layoutColumnCount
    );
    var step = Math.round(items[0].offsetWidth + getTrackGap(track));
    var target = pageStartIndex * step;

    viewport.scrollTo({ left: target, behavior: behavior || 'smooth' });
  }

  function initMobileTouchScroll(viewport, track, desktopMq) {
    var startX = 0;
    var startY = 0;
    var didPan = false;
    var panThreshold = 8;

    viewport.addEventListener(
      'touchstart',
      function (event) {
        if (desktopMq.matches || !event.touches.length) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        didPan = false;
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchmove',
      function (event) {
        if (desktopMq.matches || !event.touches.length) return;
        var dx = Math.abs(event.touches[0].clientX - startX);
        var dy = Math.abs(event.touches[0].clientY - startY);
        if (dx > panThreshold && dx > dy) {
          didPan = true;
        }
      },
      { passive: true }
    );

    track.addEventListener(
      'click',
      function (event) {
        if (desktopMq.matches || !didPan) return;
        event.preventDefault();
        event.stopPropagation();
        didPan = false;
      },
      true
    );
  }

  function initPdpSwatchPickers(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var desktopMq = window.matchMedia(DESKTOP_MQ);

    scope.querySelectorAll('[data-pdp-swatch-picker]').forEach(function (picker) {
      if (picker.dataset.pdpSwatchPickerReady === 'true') return;
      picker.dataset.pdpSwatchPickerReady = 'true';

      var viewport = picker.querySelector('[data-pdp-swatch-picker-viewport]');
      var track = picker.querySelector('[data-pdp-swatch-picker-track]');
      var prev = picker.querySelector('.pdp-swatch-picker__arrow--prev');
      var next = picker.querySelector('.pdp-swatch-picker__arrow--next');

      if (!viewport || !track) return;

      initMobileTouchScroll(viewport, track, desktopMq);

      if (!prev || !next) return;

      var layoutColumnCount = 3;

      var update = function () {
        if (!desktopMq.matches) {
          picker.classList.remove('is-overflow');
          picker.classList.remove('is-underfilled');
          picker.style.removeProperty('--pdp-swatch-column-count');
          prev.hidden = true;
          next.hidden = true;
          prev.disabled = false;
          next.disabled = false;
          return;
        }

        layoutColumnCount = getLayoutColumnCount(picker.clientWidth);
        picker.style.setProperty('--pdp-swatch-column-count', String(layoutColumnCount));

        var itemCount = track.querySelectorAll('.variant-option__button-label--has-swatch').length;
        picker.classList.toggle('is-underfilled', itemCount > 0 && itemCount < layoutColumnCount);

        var positions = getPageScrollPositions(track, layoutColumnCount);
        var overflow = positions.length > 1;

        picker.classList.toggle('is-overflow', overflow);
        prev.hidden = !overflow;
        next.hidden = !overflow;

        if (!overflow) {
          prev.disabled = true;
          next.disabled = true;
          viewport.scrollLeft = 0;
          return;
        }

        var pageIndex = getActivePageIndex(positions, viewport.scrollLeft);
        prev.disabled = pageIndex <= 0;
        next.disabled = pageIndex >= positions.length - 1;
      };

      var scrollToPage = function (direction) {
        var positions = getPageScrollPositions(track, layoutColumnCount);
        if (positions.length <= 1) return;

        var pageIndex = getActivePageIndex(positions, viewport.scrollLeft);
        var targetIndex = direction < 0 ? Math.max(0, pageIndex - 1) : Math.min(positions.length - 1, pageIndex + 1);

        viewport.scrollTo({ left: positions[targetIndex], behavior: 'smooth' });
        window.requestAnimationFrame(update);
      };

      prev.addEventListener('click', function () {
        scrollToPage(-1);
      });

      next.addEventListener('click', function () {
        scrollToPage(1);
      });

      viewport.addEventListener('scroll', update, { passive: true });

      if (typeof ResizeObserver !== 'undefined') {
        var ro = new ResizeObserver(function () {
          update();
        });
        ro.observe(picker);
        ro.observe(viewport);
        ro.observe(track);
      }

      desktopMq.addEventListener('change', update);
      window.addEventListener('resize', update, { passive: true });

      picker.addEventListener('change', function (event) {
        var input = event.target;
        if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;

        var fieldset = picker.closest('fieldset');
        var valueEl = fieldset ? fieldset.querySelector('.variant-option__swatch-value') : null;
        if (valueEl) valueEl.textContent = input.value;

        if (!desktopMq.matches) {
          requestAnimationFrame(function () {
            scrollToProductMedia(picker);
          });
          return;
        }

        requestAnimationFrame(function () {
          scrollActiveSwatchIntoView(picker, layoutColumnCount, 'smooth', desktopMq);
          update();
        });
      });

      update();
      requestAnimationFrame(function () {
        scrollActiveSwatchIntoView(picker, layoutColumnCount, 'smooth', desktopMq);
        update();
      });
    });
  }

  function boot(root) {
    initPdpSwatchPickers(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  document.addEventListener('variant:update', function (event) {
    requestAnimationFrame(function () {
      var scope = event.target && event.target.closest ? event.target.closest('.shopify-section') : null;
      if (!scope) scope = document;

      scope.querySelectorAll('[data-pdp-swatch-picker]').forEach(function (picker) {
        picker.removeAttribute('data-pdp-swatch-picker-ready');
      });

      boot(scope);
    });
  });
})();
